import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import * as Auth from "../../../Login/Auth"
import { SingleInput, SingleRedio } from '../../Res/BaseInput';
import { CancelSubmitButton } from '../../Res/BaseButton';
import { ContentBox } from '../../Content/ContentBox';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { ReqRoleAdd } from '../../../../item/ItemRole';
import { api_addRole } from '../../../../api/apiRole';


export function DepartmentPositionAdd({ id, setIsLoading }) {
  const [departmentId, setDepartmentId] = useState("")
  const [roleName, setRoleName] = useState("")
  const [isSupervisor, setIsSupervisor] = useState(0)

  useEffect(()=>{
    var rId = Auth.getval2Token("departmentId", id)
    setDepartmentId(rId)
},[])

  function toCancel() {
    window.history.back();
  }

  function toAdd() {
    if (roleName !== "") {
      var mReqRoleAdd = new ReqRoleAdd({
        departmentId,
        roleName,
        isSupervisor
      })
      api_addRole({
        mReqRoleAdd,
        success: (jsonData) => {
          Swal.fire({
            type: 'success',
            title: '提醒',
            text: '新增成功',
          }).then(function () {
            setRoleName("")
            setIsSupervisor(0)
            window.history.back(-1);
          })
        },
        failure: (err) => {
          console.log(err)
          Swal.fire({
            type: 'error',
            title: '提醒',
            text: err,
          })
        }
      })
    } else {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: '職稱 不得為空',
      })
    }
  }

  const isSupervisorItems = [
    { "val": 1, "name": "主管" },
    { "val": 0, "name": "員工" },
  ]

  var title = "職務"
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          <SingleInput title={"職稱"} val={roleName} action={setRoleName} placeholder={"經理、專員"} size={4} />
          
          <SingleRedio title={"級別"}
            arr={isSupervisorItems}
            val={isSupervisor ? 1 : 0}
            action={setIsSupervisor}
            size={4}
             />
        </div>
      </div>
    </>

  var footer =
    <div className="row">
      <div className="col-sm-3 col-sm-offset-9">
        <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={toAdd} isRight={true} />
      </div>
    </div>

  return (
    <>
      <ContentBox title={title} content={content} footer={footer} hasDrawer={true} />
      <SystemPromptInput />
    </>
  )
}